import { Component, OnInit, ViewChild } from "@angular/core";
import { DatePipe, formatDate } from "@angular/common";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
} from "@angular/forms";
import { MembershipPaymentService } from "../services/membership-payment.service";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import * as dropin from "braintree-web-drop-in";
import { Router } from "@angular/router";
import { MatStepper } from "@angular/material/stepper";
import { StripeService, StripeCardComponent } from "ngx-stripe";
import { ViewEncapsulation } from "@angular/core";
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  loadStripe,
} from "@stripe/stripe-js";
import * as moment from "moment";
// import * as moment from "moment-timezone";
import { MatRadioChange } from "@angular/material";
import { ConfirmDialogComponent } from "../confirm-dialog/confirm-dialog.component";
import { PhysicalLocationComponent } from "../dailog/physical-location/physical-location.component";
import { MatDialog } from "@angular/material/dialog";
import {TooltipPosition} from '@angular/material/tooltip';

export interface Member {
  name: string;
  relation: string;
}

declare var App;
declare var Stripe;

@Component({
  selector: "app-insurnce",
  templateUrl: "./insurnce.component.html",
  styleUrls: ["./insurnce.component.scss"],
  //   encapsulation: ViewEncapsulation.None
})
export class InsurnceComponent implements OnInit {
  @ViewChild("stepper", { static: false }) matStepper: MatStepper;

  userDetails = App.user_details;
  plan_details = JSON.parse(App.info);
  public productShortCode =
    this.plan_details.product_name != undefined
      ? this.plan_details.product_name
        .split(" ")
        .map((x) => x[0])
        .join("")
        .replace("(", "-")
      : "";
  public productImg =
    this.plan_details.img_path != undefined ? this.plan_details.img_path : "";
  public showVisaOptions =
    this.plan_details.company_id == '1' ? true : false;
  href_url = App.froent_end_url;
  public telemedicine = App.public_url + "telemedicine";
  public userMaleIcon =
    App.public_url + "telemedicine/assets/images/user_male.svg";
  public userFemaleIcon =
    App.public_url + "telemedicine/assets/images/user_female.svg";
  public userMaleColorIcon =
    App.public_url + "telemedicine/assets/images/user_male.svg";
  public userFemaleColorIcon =
    App.public_url + "telemedicine/assets/images/user_female.svg";
  public greenTickIcon =
    App.public_url + "telemedicine/assets/images/tick_green.svg";
  public plan = App.public_url + "telemedicine/assets/images/plan.svg";
  public spinner = App.public_url + "telemedicine/assets/images/spinner.gif";
  public add = App.public_url + "telemedicine/assets/images/add.svg";
  public minus = App.public_url + "telemedicine/assets/images/minus.svg";
  public inFoImg = App.public_url + "telemedicine/assets/images/info.png";
  public stripeValidation: string = "";
  public isPay: boolean = false;
  public coupounId = "";
  public addFamily: boolean = false;
  public coverage_days = 0;
  public buttonDisabled: boolean = false;
  public isState: boolean = false;
  public stateArray = [];
  public stateArray1 = [];
  public isState1: boolean = false;
  public stateArray2 = [];
  public isState2: boolean = false;
  coverage_type = [
    { id: "1", value: "FAM" },
    { id: "2", value: "FAM2" },
  ];

  States = [];

  userForm: FormGroup;
  familyForm: FormGroup;
  isEditable = true;
  submitted = false;
  currentStep = "Member Registration";
  submitStatusMsg: boolean;
  isLoading: boolean = false;
  successful_username = "";

  authorize_key = "";
  braintreeIsReady: boolean = false;
  dropIninstance: any;

  couponDiscount = "0";
  additional_charges = "2.01";
  total = 0;
  emptyCoupon = false;

  showRecurring: boolean = false;
  toogleRecurring: boolean = false;
  showOrganization: boolean = false;
  isCouponApplied: boolean = false;
  form1Submitted: boolean = false;
  form2Submitted: boolean = false;
  form3Submitted: boolean = false;
  form4Submitted: boolean = false;
  formMemberSubmitted: boolean = false;
  organizations_list = [];
  public effectiveMinDate: any;
  public prevPlanAmount: any;
  public phoneMaxLength = 12;
  public phoneMinLength = 12;
  public familyMembers = [];
  public added: boolean = false;

  public fromMinDate = moment().add(1, "days");
  public toMinDate = moment().add(1, "days");
  public isSpouse: boolean = false;
  public isChild: boolean = false;
  public isChild1: boolean = false;
  public isChild2: boolean = false;
  public notesPage: any;
  public keyPoints: any;
  public deductions: any;
  public policyLimits: any;
  public is_ad_d_options_info: any;
  public sports_options: any;
  public is_trawick: boolean = false;
  public is_img: boolean = false;
  public is_sports: boolean = false;
  public is_death: boolean = false;
  public is_global: boolean = false;
  public is_policy_fulfil: boolean = false;
  public isMail: boolean = false;
  public is_ad_d_options_info_global: any;
  public policy_fulfil_arr: any;
  public policy_full_arr_values: any;
  public primary_amount: string;
  public spouse_amount: string;
  public child_amount: string;
  public child1_amount: string;
  public child2_amount: string;
  public total_amount: any;
  public errorMsg: string = "";
  public errorMsgFinal: string = "";
  public brochure_plan = "";
  public loader: boolean = false;
  public is_student: boolean = false;
  public student_options = [];
  public appli_primary_DOB: any = "09-11-2013";
  public isCountryFieldsMatch: boolean = false;
  public policyAmount: number = 0;
  public shippingCost: number = 0;
  public totalPayable: any = 0;
  public policyName: string = '';
  public secondary_coverages = [];
  public is_secondary_coverages: boolean = false;
  public is_addition_tax:boolean = false;
  public isDisabled:boolean = false;
  public additional_tax_amount : any = 0 ; 
  public selectedCoverages = [];
  public optionalCoverageAmount: number = 0;
  
  constructor(
    private _formBuilder: FormBuilder,
    private m_pService: MembershipPaymentService,
    private datePipe: DatePipe,
    private route: Router,
    private stripeService: StripeService,
    private dialog: MatDialog
  ) {
    if (!App.info) {
      window.location.href = App.froent_end_url;
    }
    this.m_pService
      .getdeductions({
        id: this.plan_details.id,
        age: this.plan_details.age,
        add_info: true,
      })
      .subscribe((response) => {
        console.log(response, this.plan_details)
        this.notesPage = response.result.data.add_info;
        this.keyPoints = response.result.data.key_points;
        this.brochure_plan = response.result.data.brouchre_path;
        setTimeout(() => {
          if (response.result.data.is_trawick) {
            this.is_trawick = true;
            this.is_death = response.result.data.is_ad_d_options;
            this.is_sports = response.result.data.is_sports;
            this.is_ad_d_options_info =
              response.result.data.is_ad_d_options_info;
            this.sports_options = response.result.data.sports_options;
          }
          if (
            (response.result.data.is_student &&
            (this.plan_details.destination == 0 ||
              this.plan_details.destination == 1)) || (response.result.data.is_student && this.plan_details.company_id == 4)
          ) {
            this.is_student = true;
            this.student_options = response.result.data.sports_options;
          }
          if (response.result.data.is_img) {
            this.is_img = true;
            this.is_death = response.result.data.is_ad_d_options;
            console.log(this.is_death)
            this.is_sports = response.result.data.is_sports;
          }
          if (response.result.data.is_global) {
            this.is_global = true;
            this.is_ad_d_options_info_global =
              response.result.data.is_ad_d_options_info;
          }
          if (response.result.data.is_policy_fulfil) {
            this.is_policy_fulfil = true;
            this.policy_fulfil_arr = response.result.data.policy_fulfil_arr;
            this.policy_full_arr_values = response.result.data.policy_full_arr_values;
          }
        }, 1000);
      });
  }

  ngOnInit() {
    this.userForm = this._formBuilder.group({
      formArray: this._formBuilder.array([
        this._formBuilder.group({
          plan_id: [this.plan_details.id],
          citizenShip: [this.plan_details.citizenship != 'CA' ? this.plan_details.citizenship : ''],
          residence: [""],
          traveling_to: [
            this.plan_details.destination == 0 ||
              this.plan_details.destination == 1
              ? "US"
              : "",
          ],
          coverage_start_date: [moment(this.plan_details.effective_date)],
          coverage_end_date: [moment(this.plan_details.termination_date)],
          primary_dob: [""],
          spouse_coverage: ["no"],
          spouse_dob: [""],
          child_coverage: ["no"],
          child1_dob: [""],
          child2_dob: [""],
          child3_dob: [""],
          email: [this.plan_details.email],
          visa_type: [""],
          school_status: [""],
          eligibility: ["1"],
          univerity_name: [""],
          payment_type :[this.plan_details.payment_type] 
        }),
        this._formBuilder.group({
          AD: [false],
          KR: [false],
          PL: [false],
          SP: [false],
          optional_coverage_amount: ["0"],
          secondary_coverages: this._formBuilder.array([]),
          deductable: [this.plan_details.deduction],
          policy_limit: [this.plan_details.max_coverage],
          is_ad_d_options_info: ["25000"],
          is_ad_d_options_info_global: [""],
          sports_options: ["no"],
          sports_rider: ["no"],
          plus_rider: ["no"],
          aditional_coverage: [""],
          max_coverage: [this.plan_details.amount],
          total_amount: [""],
          total_payable_amount: [""],
          shipping_amount:[""],
          policy_fulfil: ["0"],
          same_as_mailing: [""],
          mailing_first_name: [""],
          mailing_last_name: [""],
          mailing_address_line_1: [""],
          mailing_address_line_2: [""],
          mailing_country: [""],
          mailing_city: [""],
          mailing_state: [""],
          mailing_postal_code: [""],
          mailing_email_confirm: [""],
          primary_first_name: [""],
          primary_last_name: [""],
          date_of_birth: [""],
          gender: [""],
          primary_citizenShip: [""],
          passport: [""],
          spouse_first_name: [""],
          spouse_last_name: [""],
          spouse_date_of_birth: [""],
          spouse_gender: [""],
          spouse_citizenShip: [""],
          spouse_passport: [""],
          child1_first_name: [""],
          child1_last_name: [""],
          child1_date_of_birth: [""],
          child1_gender: [""],
          child1_citizenShip: [""],
          child1_passport: [""],
          child2_first_name: [""],
          child2_last_name: [""],
          child2_date_of_birth: [""],
          child2_gender: [""],
          child2_citizenShip: [""],
          child2_passport: [""],
          child3_first_name: [""],
          child3_last_name: [""],
          child3_date_of_birth: [""],
          child3_gender: [""],
          child3_citizenShip: [""],
          child3_passport: [""],
          date_of_departure: [""],
          date_of_return: [""],
          same_as_primary: [""],
          first_name: [""],
          last_name: [""],
          address_line_1: [""],
          address_line_2: [""],
          country: [""],
          city: [""],
          state: [""],
          postal_code: [""],
          email_confirm: [""],
          mobile: [""],
          mobile_msg: [""],
          beneficiary_name: [""],
          relationship: [""],
          policy_receive_as: [""],
          hear_about_us: [""],
          customer_agent_help: [""],
          is_ack: [""],
          dp_rider: ["no"],
          telehealth_rider: ["no"],
        }),
        this._formBuilder.group({
          card_type: [""],
          card_name: [""],
          card_number: [""],
          cvv_number: [""],
          card_expire_month: [""],
          card_expire_year: [""],
          same_as_billing: [""],
          billing_first_name: [""],
          billing_last_name: [""],
          billing_address_line_1: [""],
          billing_address_line_2: [""],
          billing_country: [""],
          billing_city: [""],
          billing_state: [""],
          billing_postal_code: [""],
          billing_email_confirm: [""],
          billing_mobile: [""],
          billing_mobile_msg: [""],
        }),
      ]),
    });
  }

  downloadBroucher() {
    // window.open()
    return this.m_pService.getBroucher({ id: this.plan_details.id });
  }

  downloadTnCFile() {
    // window.open()
    return this.m_pService.downloadTnCFile({ id: this.plan_details.id });
  }

  downloadDescrition() {
    window.open(
      App.base_url +
      "/storage/plan_descriptions/" +
      this.brochure_plan +
      ".pdf",
      "_blank"
    );
    // return this.m_pService.getBroucher({id: this.plan_details.id})
  }

  showOptions(event) {
    this.toogleRecurring = event.checked;
  }

  eligibilityOption(event) {
    if (event.value) {
      const confirmDialog = this.dialog.open(ConfirmDialogComponent, {
        data: {
          dialog: false,
          title: "Eligibility Requirements",
          message:
            "The Participant must meet the eligibility requirements of this plan in order to purchase. ",
        },
      });
      confirmDialog.afterClosed().subscribe((result) => {
        this.userForm
          .get("formArray")
        ["controls"][0].controls.eligibility.patchValue("1");
      });
    }
  }

  goToPage(event, userId = 0) {
    var newForm = document.createElement("form");
    newForm.setAttribute("id", "newForm");
    newForm.setAttribute("method", "post");
    newForm.setAttribute("action", App.froent_end_url + event);

    var hidden_user = document.createElement("input");
    hidden_user.type = "hidden";
    hidden_user.id = "userId";
    hidden_user.name = "userId";
    hidden_user.value = App.user_details.id ? App.user_details.id : userId;
    var hidden_flag = document.createElement("input");
    hidden_flag.type = "hidden";
    hidden_flag.id = "nav_flag";
    hidden_flag.name = "nav_flag";
    hidden_flag.value = "true";

    newForm.appendChild(hidden_user);
    newForm.appendChild(hidden_flag);

    document.body.appendChild(newForm);

    newForm.submit();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  spouseCoverageOption($event: MatRadioChange) {
    if ($event.value === "yes") {
      this.isSpouse = true;
       this.userForm.get('formArray')['controls'][0].controls.spouse_dob.setValidators([Validators.required]);
       this.userForm.get('formArray')['controls'][1].controls.spouse_first_name.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_first_name.setValidators([Validators.required]);
      this.userForm.get('formArray')['controls'][1].controls.spouse_first_name.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_last_name.setValidators([Validators.required]);
      this.userForm.get('formArray')['controls'][1].controls.spouse_last_name.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_gender.setValidators([Validators.required]);
      this.userForm.get('formArray')['controls'][1].controls.spouse_gender.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_date_of_birth.setValidators([Validators.required]);
      this.userForm.get('formArray')['controls'][1].controls.spouse_date_of_birth.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_citizenShip.setValidators([Validators.required]);
      this.userForm.get('formArray')['controls'][1].controls.spouse_citizenShip.updateValueAndValidity();
    } else {
      this.isSpouse = false;
      this.userForm.get('formArray')['controls'][1].controls.spouse_first_name.clearValidators();
      this.userForm.get('formArray')['controls'][1].controls.spouse_first_name.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_last_name.clearValidators();
      this.userForm.get('formArray')['controls'][1].controls.spouse_last_name.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_gender.clearValidators();
      this.userForm.get('formArray')['controls'][1].controls.spouse_gender.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_date_of_birth.clearValidators();
      this.userForm.get('formArray')['controls'][1].controls.spouse_date_of_birth.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][1].controls.spouse_citizenShip.clearValidators();
      this.userForm.get('formArray')['controls'][1].controls.spouse_citizenShip.updateValueAndValidity();
      this.userForm.get('formArray')['controls'][0].controls.spouse_dob.clearValidators();
      this.userForm.get('formArray')['controls'][0].controls.spouse_dob.updateValueAndValidity();
      this.userForm.get("formArray")["controls"][0].controls.spouse_dob.value =
        "";
    }
  }

  goBack(stepper: MatStepper) {
    this.matStepper.previous();
  }

  backToInsurance() {
    window.location.href = App.froent_end_url;
  }

  childCoverageOption($event: MatRadioChange) {
    if ($event.value === "yes") {
      this.isChild = true;
      // this.userForm.get('formArray')['controls'][0].controls.spouse_dob.setValidators([Validators.required]);
    } else {
      this.isChild = false;
      this.userForm.get("formArray")["controls"][0].controls.child1_dob.value =
        "";
      this.userForm.get("formArray")["controls"][0].controls.child2_dob.value =
        "";
      this.userForm.get("formArray")["controls"][0].controls.child3_dob.value =
        "";
    }
  }

  get formArray(): AbstractControl | null {
    return this.userForm.get("formArray");
  }

  dobMin() {
    return new Date(
      new Date().getFullYear() - 18,
      new Date().getMonth(),
      new Date().getDate()
    );
  }
  dobChildMin() {
    return new Date(
      new Date().getFullYear() - 1,
      new Date().getMonth(),
      new Date().getDate()
    );
  }
  dobChild17Years() {
    return new Date(
      new Date().getFullYear() - 2,
      new Date().getMonth(),
      new Date().getDate()
    );
  }
  getStartDate() {
    // let today = new Date(this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd'));
    // let effectiveDate = new Date( today.getFullYear(), today.getMonth(), today.getDate());
    // console.log(effectiveDate);
    // setTimeout(() => {
    // let finalDate = this.userForm.get('formArray')['controls'][0].controls.effective_date.value;
    // let timezone = new Date().getTimezoneOffset();
    // 	this.userForm.get('formArray')['controls'][0].controls.effective_date.value = timezone > 0 ? new Date(this.effectiveMinDate) : this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd')
    // 	this.familyForm.get('effective_date').setValue(timezone > 0 ? new Date(this.effectiveMinDate) : this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd'))
    return new Date();
    // })
  }

  addEvent(type: string, event) {
    // this.userForm.get('formArray')['controls'][0].controls.effective_date.value = this.datePipe.transform(this.userForm.get('formArray')['controls'][0].controls.effective_date.value, 'yyyy-MM-dd');
    let finalDate = new Date(
      this.datePipe.transform(event.value, "yyyy,MM,dd")
    );
    this.effectiveMinDate = finalDate;
    this.userForm.get("formArray")[
      "controls"
    ][0].controls.effective_date.value = this.datePipe.transform(
      this.effectiveMinDate,
      "yyyy-MM-dd"
    );
    // this.getEndDate(event.value)
    // alert(this.effectiveMinDate);
  }

  getEndDate() {
    let count =
      this.userForm.get("formArray")["controls"][0].controls.noOfMonths.value;
    // let effectiveMinDate = this.userForm.get('formArray')['controls'][0].controls.effective_date.value;
    if (count == "") {
      return false;
    }
    let today = new Date(this.effectiveMinDate);
    let currMonth = today.getMonth();
    // let timezone = new Date().getTimezoneOffset();

    let endDate = new Date(today.getFullYear(), currMonth + parseInt(count), 0);
    this.userForm.get("formArray")[
      "controls"
    ][0].controls.termination_date.value = this.datePipe.transform(
      endDate,
      "yyyy-MM-dd"
    );
    this.familyForm
      .get("termination_date")
      .setValue(this.datePipe.transform(endDate, "yyyy-MM-dd"));
    return new Date(this.datePipe.transform(endDate, "yyyy-MM-dd"));
  }

  goTo(event) {
    var newForm = document.createElement("form");
    newForm.setAttribute("id", "newForm");
    newForm.setAttribute("method", "post");
    newForm.setAttribute("action", App.froent_end_url + event);

    var hidden_user = document.createElement("input");
    hidden_user.type = "hidden";
    hidden_user.id = "userId";
    hidden_user.name = "userId";
    hidden_user.value = App.user_details.id;

    var hidden_flag = document.createElement("input");
    hidden_flag.type = "hidden";
    hidden_flag.id = "nav_flag";
    hidden_flag.name = "nav_flag";
    hidden_flag.value = "true";

    newForm.appendChild(hidden_user);
    newForm.appendChild(hidden_flag);

    document.body.appendChild(newForm);

    newForm.submit();
  }

  selectionChange(event: StepperSelectionEvent) {
    let stepIndex = event.selectedIndex;
    if (stepIndex == 0) {
      this.currentStep = "Payment";
    } else if (stepIndex == 1) {
      this.currentStep = "Payment";
    } else {
      this.currentStep = "Confirmation";
    }
  }

  policyChange(event) {
    let policyKey = this.userForm.get('formArray')['controls'][1].value.policy_fulfil;
    let policyFullName = this.policy_fulfil_arr[parseInt(event.value)];
    this.policyName = policyFullName.substr(0,policyFullName.indexOf(':')+1)
    this.policyAmount = this.policy_full_arr_values[parseInt(policyKey)];
    this.shippingCost=this.policyAmount;
    this.userForm.get("formArray")
    ["controls"][1].controls.shipping_amount.patchValue(
      parseFloat((+this.shippingCost).toString()).toFixed(2)
    );
    this.totalPayable = parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
    this.userForm.get("formArray")
            ["controls"][1].controls.total_payable_amount.patchValue(
              parseFloat((+this.totalPayable).toString()).toFixed(2)
            );
    console.log(this.policyAmount)
    if (this.is_img && event.value >= 1) {
      this.isMail = true;
    } else {
      this.isMail = false;
    }
  }

  setSecondaryCoverage(event,coverage){
    if( coverage.key == 'AD') {
      event.checked ? this.selectedCoverages.push('AD') : this.selectedCoverages.splice(this.selectedCoverages.indexOf('AD'),1);
    }
    if( coverage.key == 'KR') {
      event.checked ? this.selectedCoverages.push('KR') : this.selectedCoverages.splice(this.selectedCoverages.indexOf('KR'),1);
    }
    if( coverage.key == 'PL') {
      event.checked ? this.selectedCoverages.push('PL') : this.selectedCoverages.splice(this.selectedCoverages.indexOf('PL'),1);
    }
    if( coverage.key == 'SP') {
      event.checked ? this.selectedCoverages.push('SP') : this.selectedCoverages.splice(this.selectedCoverages.indexOf('SP'),1);
    }
    this.optionalCoverageAmount = event.checked ? +coverage.amount : -coverage.amount;
    this.total_amount = parseFloat((+this.total_amount + this.optionalCoverageAmount).toString()).toFixed(2);
    this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
    this.userForm.get("formArray")
            ["controls"][1].controls.total_amount.patchValue(
              parseFloat((+this.total_amount).toString()).toFixed(2)
            );
            this.userForm.get("formArray")
            ["controls"][1].controls.total_payable_amount.patchValue(
              parseFloat((+this.totalPayable).toString()).toFixed(2)
            );
  }

  changeDeductable(event) {
    this.isDisabled=true;
    this.userForm.get("formArray")["controls"][1].value.deductable =
      event.value;
    // this.coverageEndDate = moment(this.userForm.get('formArray')['controls'][0].value.coverage_end_date, 'yyyy-MM-dd').add(1, 'days');
    this.page2(false);
  }

  changePolicyLimit(event) {
    this.isDisabled=true;
    this.userForm.get("formArray")["controls"][1].value.policy_limit =
      event.value;
    this.page2(false);
  }

  changeAdditionalDeath(event) {
    this.userForm.get("formArray")["controls"][1].value.is_ad_d_options_info =
      event.value;
    this.page2(false);
  }
  changeAdditionalSport(event) {
    this.userForm.get("formArray")["controls"][1].value.sports_options =
      event.value;
    this.page2(false);
  }
  sportsRider(event) {
    this.userForm.get("formArray")["controls"][1].value.sports_rider =
      event.value;
    this.page2(false);
  }
  plusRider(event) {
    this.userForm.get("formArray")["controls"][1].value.plus_rider =
      event.value;
    this.page2(false);
  }

  dpRider(event) {
    this.userForm.get("formArray")["controls"][1].value.dp_rider =
      event.value;
    this.page2(false);
  }

  telehealthRider(event) {
    this.userForm.get("formArray")["controls"][1].value.telehealth_rider =
      event.value;
    this.page2(false);
  }

  changeCountry(event) {
    this.stateArray = [];
    this.is_addition_tax=false;
      if(this.additional_tax_amount>0 && this.plan_details.company_id==4){
      this.total_amount = parseFloat((+this.total_amount - this.additional_tax_amount).toString()).toFixed(2);
      this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
      this.additional_tax_amount = 0;
      this.userForm
              .get("formArray")
            ["controls"][1].controls.total_amount.patchValue(
              parseFloat((this.total_amount).toString()).toFixed(2)
            );
            this.userForm.get("formArray")
            ["controls"][1].controls.total_payable_amount.patchValue(
              parseFloat((+this.totalPayable).toString()).toFixed(2)
            );

      }
    switch (event.value) {
      case "US":
        this.isState = true;
        this.stateArray = [
          { value: "AK", name: "Alaska" },
          { value: "AL", name: "Alabama" },
          { value: "AR", name: "Arkansas" },
          { value: "AZ", name: "Arizona" },
          { value: "CA", name: "California" },
          { value: "CO", name: "Colorado" },
          { value: "CT", name: "Connecticut" },
          { value: "DC", name: "DistrictofColumbia" },
          { value: "DE", name: "Delaware" },
          { value: "FL", name: "Florida" },
          { value: "GA", name: "Georgia" },
          { value: "HI", name: "Hawaii" },
          { value: "IA", name: "Iowa" },
          { value: "ID", name: "Idaho" },
          { value: "IL", name: "Illinois" },
          { value: "IN", name: "Indiana" },
          { value: "KS", name: "Kansas" },
          { value: "KY", name: "Kentucky" },
          { value: "LA", name: "Louisiana" },
          { value: "MA", name: "Massachusetts" },
          { value: "MD", name: "Maryland" },
          { value: "ME", name: "Maine" },
          { value: "MI", name: "Michigan" },
          { value: "MN", name: "Minnesota" },
          { value: "MO", name: "Missouri" },
          { value: "MS", name: "Mississippi" },
          { value: "MT", name: "Montana" },
          { value: "NC", name: "NorthCarolina" },
          { value: "ND", name: "NorthDakota" },
          { value: "NE", name: "Nebraska" },
          { value: "NH", name: "NewHampshire" },
          { value: "NJ", name: "NewJersey" },
          { value: "NM", name: "NewMexico" },
          { value: "NV", name: "Nevada" },
          { value: "NY", name: "NewYork" },
          { value: "OH", name: "Ohio" },
          { value: "OK", name: "Oklahoma" },
          { value: "OR", name: "Oregon" },
          { value: "PA", name: "Pennsylvania" },
          { value: "RI", name: "RhodeIsland" },
          { value: "SC", name: "SouthCarolina" },
          { value: "SD", name: "SouthDakota" },
          { value: "TN", name: "Tennessee" },
          { value: "TX", name: "Texas" },
          { value: "UT", name: "Utah" },
          { value: "VA", name: "Virginia" },
          { value: "VT", name: "Vermont" },
          { value: "WA", name: "Washington" },
          { value: "WI", name: "Wisconsin" },
          { value: "WV", name: "WestVirginia" },
          { value: "WY", name: "Wyoming" },
        ];
        if(this.userForm.get("formArray")["controls"][1].value.state==='FL' && this.plan_details.company_id==4){
          this.is_addition_tax=true;
          this.additional_tax_amount = parseFloat(this.primary_amount) * 0.05;
          this.total_amount = parseFloat((+this.total_amount + this.additional_tax_amount).toString()).toFixed(2);
          this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
          this.additional_tax_amount = parseFloat(this.additional_tax_amount).toFixed(2);
          this.userForm
              .get("formArray")
            ["controls"][1].controls.total_amount.patchValue(
              parseFloat((this.total_amount).toString()).toFixed(2)
            );
            this.userForm.get("formArray")
            ["controls"][1].controls.total_payable_amount.patchValue(
              parseFloat((+this.totalPayable).toString()).toFixed(2)
            );
        }
        break;
      case "IN":
        this.isState = true;
        this.stateArray = [
          { value: "AN", name: "Andaman and Nicobar Islands" },
          { value: "AP", name: "Andhra Pradesh" },
          { value: "AR", name: "Arunachal Pradesh" },
          { value: "AS", name: "Assam" },
          { value: "BR", name: "Bihar" },
          { value: "CG", name: "Chhattisgarh" },
          { value: "CH", name: "Chandigarh" },
          { value: "DN", name: "Dadra and Nagar Haveli" },
          { value: "DD", name: "Daman and Diu" },
          { value: "DL", name: "Delhi" },
          { value: "GA", name: "Goa" },
          { value: "GJ", name: "Gujarat" },
          { value: "HR", name: "Haryana" },
          { value: "HP", name: "Himachal Pradesh" },
          { value: "JK", name: "Jammu and Kashmir" },
          { value: "JH", name: "Jharkhand" },
          { value: "KA", name: "Karnataka" },
          { value: "KL", name: "Kerala" },
          { value: "LA", name: "Ladakh" },
          { value: "LD", name: "Lakshadweep" },
          { value: "MP", name: "Madhya Pradesh" },
          { value: "MH", name: "Maharashtra" },
          { value: "MN", name: "Manipur" },
          { value: "ML", name: "Meghalaya" },
          { value: "MZ", name: "Mizoram" },
          { value: "NL", name: "Nagaland" },
          { value: "OD", name: "Odisha" },
          { value: "PB", name: "Punjab" },
          { value: "PY", name: "Pondicherry" },
          { value: "RJ", name: "Rajasthan" },
          { value: "SK", name: "Sikkim" },
          { value: "TN", name: "Tamil Nadu" },
          { value: "TS", name: "Telangana" },
          { value: "TR", name: "Tripura" },
          { value: "UP", name: "Uttar Pradesh" },
          { value: "UK", name: "Uttarakhand" },
          { value: "WB", name: "West Bengal" },
        ];
        break;
      case "CA":
        this.isState = true;
        this.stateArray = [
          { value: "AB", name: "Alberta" },
          { value: "BC", name: "British Columbia" },
          { value: "MB", name: "Manitoba" },
          { value: "NB", name: "New Brunswick" },
          { value: "NL", name: "Newfoundland and Labrador" },
          { value: "NS", name: "Nova Scotia" },
          { value: "ON", name: "Ontario" },
          { value: "PE", name: "Prince Edward Island" },
          { value: "QC", name: "Quebec" },
          { value: "SK", name: "Saskatchewan" },
          { value: "NT", name: "Northwest Territories" },
          { value: "NU", name: "Nunavut" },
          { value: "YT", name: "Yukon" },
        ];
        if(this.matStepper.selectedIndex==1){
          this.physicalLocationDailog('Canada','Country');
        }
        break;
      case "AU":
        this.isState = false;
        this.stateArray = [];
        this.userForm.get("formArray")["controls"][1].value.state="";
        if(this.matStepper.selectedIndex==1){
          this.physicalLocationDailog('Australia','Country');
        }
        break;
      default:
        this.isState = false;
        this.stateArray = [];
        this.userForm.get("formArray")["controls"][1].value.state="";
        break;
    }
  }

  changeCountry1(event) {
    this.stateArray1 = [];
    switch (event.value) {
      case "US":
        this.isState1 = true;
        this.stateArray1 = [
          { value: "AK", name: "Alaska" },
          { value: "AL", name: "Alabama" },
          { value: "AR", name: "Arkansas" },
          { value: "AZ", name: "Arizona" },
          { value: "CA", name: "California" },
          { value: "CO", name: "Colorado" },
          { value: "CT", name: "Connecticut" },
          { value: "DC", name: "DistrictofColumbia" },
          { value: "DE", name: "Delaware" },
          { value: "FL", name: "Florida" },
          { value: "GA", name: "Georgia" },
          { value: "HI", name: "Hawaii" },
          { value: "IA", name: "Iowa" },
          { value: "ID", name: "Idaho" },
          { value: "IL", name: "Illinois" },
          { value: "IN", name: "Indiana" },
          { value: "KS", name: "Kansas" },
          { value: "KY", name: "Kentucky" },
          { value: "LA", name: "Louisiana" },
          { value: "MA", name: "Massachusetts" },
          { value: "MD", name: "Maryland" },
          { value: "ME", name: "Maine" },
          { value: "MI", name: "Michigan" },
          { value: "MN", name: "Minnesota" },
          { value: "MO", name: "Missouri" },
          { value: "MS", name: "Mississippi" },
          { value: "MT", name: "Montana" },
          { value: "NC", name: "NorthCarolina" },
          { value: "ND", name: "NorthDakota" },
          { value: "NE", name: "Nebraska" },
          { value: "NH", name: "NewHampshire" },
          { value: "NJ", name: "NewJersey" },
          { value: "NM", name: "NewMexico" },
          { value: "NV", name: "Nevada" },
          { value: "NY", name: "NewYork" },
          { value: "OH", name: "Ohio" },
          { value: "OK", name: "Oklahoma" },
          { value: "OR", name: "Oregon" },
          { value: "PA", name: "Pennsylvania" },
          { value: "RI", name: "RhodeIsland" },
          { value: "SC", name: "SouthCarolina" },
          { value: "SD", name: "SouthDakota" },
          { value: "TN", name: "Tennessee" },
          { value: "TX", name: "Texas" },
          { value: "UT", name: "Utah" },
          { value: "VA", name: "Virginia" },
          { value: "VT", name: "Vermont" },
          { value: "WA", name: "Washington" },
          { value: "WI", name: "Wisconsin" },
          { value: "WV", name: "WestVirginia" },
          { value: "WY", name: "Wyoming" },
        ];
        break;
      case "IN":
        this.isState1 = true;
        this.stateArray1 = [
          { value: "AN", name: "Andaman and Nicobar Islands" },
          { value: "AP", name: "Andhra Pradesh" },
          { value: "AR", name: "Arunachal Pradesh" },
          { value: "AS", name: "Assam" },
          { value: "BR", name: "Bihar" },
          { value: "CG", name: "Chhattisgarh" },
          { value: "CH", name: "Chandigarh" },
          { value: "DN", name: "Dadra and Nagar Haveli" },
          { value: "DD", name: "Daman and Diu" },
          { value: "DL", name: "Delhi" },
          { value: "GA", name: "Goa" },
          { value: "GJ", name: "Gujarat" },
          { value: "HR", name: "Haryana" },
          { value: "HP", name: "Himachal Pradesh" },
          { value: "JK", name: "Jammu and Kashmir" },
          { value: "JH", name: "Jharkhand" },
          { value: "KA", name: "Karnataka" },
          { value: "KL", name: "Kerala" },
          { value: "LA", name: "Ladakh" },
          { value: "LD", name: "Lakshadweep" },
          { value: "MP", name: "Madhya Pradesh" },
          { value: "MH", name: "Maharashtra" },
          { value: "MN", name: "Manipur" },
          { value: "ML", name: "Meghalaya" },
          { value: "MZ", name: "Mizoram" },
          { value: "NL", name: "Nagaland" },
          { value: "OD", name: "Odisha" },
          { value: "PB", name: "Punjab" },
          { value: "PY", name: "Pondicherry" },
          { value: "RJ", name: "Rajasthan" },
          { value: "SK", name: "Sikkim" },
          { value: "TN", name: "Tamil Nadu" },
          { value: "TS", name: "Telangana" },
          { value: "TR", name: "Tripura" },
          { value: "UP", name: "Uttar Pradesh" },
          { value: "UK", name: "Uttarakhand" },
          { value: "WB", name: "West Bengal" },
        ];
        break;
      case "CA":
        this.isState1 = true;
        this.stateArray1 = [
          { value: "AB", name: "Alberta" },
          { value: "BC", name: "British Columbia" },
          { value: "MB", name: "Manitoba" },
          { value: "NB", name: "New Brunswick" },
          { value: "NL", name: "Newfoundland and Labrador" },
          { value: "NS", name: "Nova Scotia" },
          { value: "ON", name: "Ontario" },
          { value: "PE", name: "Prince Edward Island" },
          { value: "QC", name: "Quebec" },
          { value: "SK", name: "Saskatchewan" },
          { value: "NT", name: "Northwest Territories" },
          { value: "NU", name: "Nunavut" },
          { value: "YT", name: "Yukon" },
        ];
        break;
      default:
        this.isState1 = false;
        this.stateArray1 = [];
        this.userForm
          .get("formArray")
        ["controls"][2].controls.billing_state.patchValue("");
        break;
    }
  }

  changeCountry2(event) {
    this.stateArray2 = [];
    switch (event.value) {
      case "US":
        this.isState2 = true;
        this.stateArray2 = [
          { value: "AK", name: "Alaska" },
          { value: "AL", name: "Alabama" },
          { value: "AR", name: "Arkansas" },
          { value: "AZ", name: "Arizona" },
          { value: "CA", name: "California" },
          { value: "CO", name: "Colorado" },
          { value: "CT", name: "Connecticut" },
          { value: "DC", name: "DistrictofColumbia" },
          { value: "DE", name: "Delaware" },
          { value: "FL", name: "Florida" },
          { value: "GA", name: "Georgia" },
          { value: "HI", name: "Hawaii" },
          { value: "IA", name: "Iowa" },
          { value: "ID", name: "Idaho" },
          { value: "IL", name: "Illinois" },
          { value: "IN", name: "Indiana" },
          { value: "KS", name: "Kansas" },
          { value: "KY", name: "Kentucky" },
          { value: "LA", name: "Louisiana" },
          { value: "MA", name: "Massachusetts" },
          { value: "MD", name: "Maryland" },
          { value: "ME", name: "Maine" },
          { value: "MI", name: "Michigan" },
          { value: "MN", name: "Minnesota" },
          { value: "MO", name: "Missouri" },
          { value: "MS", name: "Mississippi" },
          { value: "MT", name: "Montana" },
          { value: "NC", name: "NorthCarolina" },
          { value: "ND", name: "NorthDakota" },
          { value: "NE", name: "Nebraska" },
          { value: "NH", name: "NewHampshire" },
          { value: "NJ", name: "NewJersey" },
          { value: "NM", name: "NewMexico" },
          { value: "NV", name: "Nevada" },
          { value: "NY", name: "NewYork" },
          { value: "OH", name: "Ohio" },
          { value: "OK", name: "Oklahoma" },
          { value: "OR", name: "Oregon" },
          { value: "PA", name: "Pennsylvania" },
          { value: "RI", name: "RhodeIsland" },
          { value: "SC", name: "SouthCarolina" },
          { value: "SD", name: "SouthDakota" },
          { value: "TN", name: "Tennessee" },
          { value: "TX", name: "Texas" },
          { value: "UT", name: "Utah" },
          { value: "VA", name: "Virginia" },
          { value: "VT", name: "Vermont" },
          { value: "WA", name: "Washington" },
          { value: "WI", name: "Wisconsin" },
          { value: "WV", name: "WestVirginia" },
          { value: "WY", name: "Wyoming" },
        ];
        break;
      case "IN":
        this.isState2 = true;
        this.stateArray2 = [
          { value: "AN", name: "Andaman and Nicobar Islands" },
          { value: "AP", name: "Andhra Pradesh" },
          { value: "AR", name: "Arunachal Pradesh" },
          { value: "AS", name: "Assam" },
          { value: "BR", name: "Bihar" },
          { value: "CG", name: "Chhattisgarh" },
          { value: "CH", name: "Chandigarh" },
          { value: "DN", name: "Dadra and Nagar Haveli" },
          { value: "DD", name: "Daman and Diu" },
          { value: "DL", name: "Delhi" },
          { value: "GA", name: "Goa" },
          { value: "GJ", name: "Gujarat" },
          { value: "HR", name: "Haryana" },
          { value: "HP", name: "Himachal Pradesh" },
          { value: "JK", name: "Jammu and Kashmir" },
          { value: "JH", name: "Jharkhand" },
          { value: "KA", name: "Karnataka" },
          { value: "KL", name: "Kerala" },
          { value: "LA", name: "Ladakh" },
          { value: "LD", name: "Lakshadweep" },
          { value: "MP", name: "Madhya Pradesh" },
          { value: "MH", name: "Maharashtra" },
          { value: "MN", name: "Manipur" },
          { value: "ML", name: "Meghalaya" },
          { value: "MZ", name: "Mizoram" },
          { value: "NL", name: "Nagaland" },
          { value: "OD", name: "Odisha" },
          { value: "PB", name: "Punjab" },
          { value: "PY", name: "Pondicherry" },
          { value: "RJ", name: "Rajasthan" },
          { value: "SK", name: "Sikkim" },
          { value: "TN", name: "Tamil Nadu" },
          { value: "TS", name: "Telangana" },
          { value: "TR", name: "Tripura" },
          { value: "UP", name: "Uttar Pradesh" },
          { value: "UK", name: "Uttarakhand" },
          { value: "WB", name: "West Bengal" },
        ];
        break;
      case "CA":
        this.isState2 = true;
        this.stateArray2 = [
          { value: "AB", name: "Alberta" },
          { value: "BC", name: "British Columbia" },
          { value: "MB", name: "Manitoba" },
          { value: "NB", name: "New Brunswick" },
          { value: "NL", name: "Newfoundland and Labrador" },
          { value: "NS", name: "Nova Scotia" },
          { value: "ON", name: "Ontario" },
          { value: "PE", name: "Prince Edward Island" },
          { value: "QC", name: "Quebec" },
          { value: "SK", name: "Saskatchewan" },
          { value: "NT", name: "Northwest Territories" },
          { value: "NU", name: "Nunavut" },
          { value: "YT", name: "Yukon" },
        ];
        break;
      default:
        this.isState2 = false;
        this.stateArray2 = [];
        this.userForm
          .get("formArray")
        ["controls"][1].controls.mailing_state.patchValue("");
        break;
    }
  }

  changeAdditionalDeathGloabl(event) {
    this.userForm.get("formArray")[
      "controls"
    ][1].value.is_ad_d_options_info_global = event.value;
    this.page2(false);
  }

  public dobLabel: any;
  public coverageEndDate: any;
  public primaryDOB_review: any;
  public device_protection = false;
  public img_telemedicine = false;
  public is_adventure_rider: any;
  public is_telehealth: any;
  page2(step = true) {
    this.form1Submitted = true;
    this.userForm.get("formArray")[
      "controls"
    ][0].controls.coverage_start_date.value = this.datePipe.transform(
      this.userForm.get("formArray")["controls"][0].value.coverage_start_date,
      "yyyy-MM-dd"
    );
    this.coverageEndDate = moment(this.userForm.get("formArray")["controls"][0].value.coverage_end_date)
    .add(1, "days")
    .format("YYYY-MM-DD");

    this.userForm.get("formArray")[
      "controls"
    ][0].controls.coverage_end_date.value = this.datePipe.transform(
      this.userForm.get("formArray")["controls"][0].value.coverage_end_date,
      "yyyy-MM-dd"
    );
    // this.datePipe.transform(this.effectiveMinDate, 'yyyy-MM-dd');
    this.primaryDOB_review = formatDate(
      this.userForm.get("formArray")["controls"][0].value.primary_dob,
      "mediumDate",
      "en-US",
      "GMT"
    ); //this.datePipe.transform(this.userForm.get('formArray')['controls'][0].value.primary_dob, 'medium');
    if (this.userForm.get("formArray")["controls"][0].valid) {
      this.buttonDisabled = true;
      this.loader = true;
      this.userForm.get("formArray")["controls"][0].value.primary_dob !== ""
        ? this.userForm
          .get("formArray")
        ["controls"][0].controls.primary_dob.patchValue(
          moment(
            this.userForm.get("formArray")["controls"][0].value.primary_dob
          ).format()
        )
        : "";
      this.userForm.get("formArray")["controls"][0].value.spouse_dob !== ""
        ? this.userForm
          .get("formArray")
        ["controls"][0].controls.spouse_dob.patchValue(
          moment(
            this.userForm.get("formArray")["controls"][0].value.spouse_dob
          ).format()
        )
        : "";
      this.userForm.get("formArray")["controls"][0].value.child1_dob !== ""
        ? this.userForm
          .get("formArray")
        ["controls"][0].controls.child1_dob.patchValue(
          moment(
            this.userForm.get("formArray")["controls"][0].value.child1_dob
          ).format()
        )
        : "";
      this.userForm.get("formArray")["controls"][0].value.child2_dob !== ""
        ? this.userForm
          .get("formArray")
        ["controls"][0].controls.child2_dob.patchValue(
          moment(
            this.userForm.get("formArray")["controls"][0].value.child2_dob
          ).format()
        )
        : "";
      this.userForm.get("formArray")["controls"][0].value.child3_dob !== ""
        ? this.userForm
          .get("formArray")
        ["controls"][0].controls.child3_dob.patchValue(
          moment(
            this.userForm.get("formArray")["controls"][0].value.child3_dob
          ).format()
        )
        : "";
      this.coverage_days = moment(
        this.userForm.get("formArray")["controls"][0].controls.coverage_end_date
          .value
      ).diff(
        moment(
          this.userForm.get("formArray")["controls"][0].controls
            .coverage_start_date.value
        ),
        "days"
      );
      
      this.m_pService
        .getdeductions({
          id: this.plan_details.id,
          age: this.userForm.get("formArray")["controls"][0].value.primary_dob,
        })
        .subscribe((response) => {
          if (response.result.data.is_trawick) {
            this.is_trawick = true;
            this.is_death = response.result.data.is_ad_d_options;
            this.is_sports = response.result.data.is_sports;
            this.is_ad_d_options_info =
              response.result.data.is_ad_d_options_info;
            this.sports_options = response.result.data.sports_options;
          }
          if (response.result.data.is_img) {
            this.is_img = true;
            this.is_death = response.result.data.sports_rider;
            this.is_sports = response.result.data.plus_rider;
            this.device_protection = response.result.data.deviceprotection;
            this.img_telemedicine = response.result.data.telemedicine;
          }
          if (response.result.data.is_global) {
            this.is_global = true;
            this.is_ad_d_options_info_global =
              response.result.data.is_ad_d_options_info;
          }
          this.deductions = response.result.data.deductions;
          this.policyLimits = response.result.data.max_cov_options;
        });
      let quotesPrice = {
        secondary_coverages: this.selectedCoverages,
        citizenship:
          this.userForm.get("formArray")["controls"][0].value.citizenShip,
        destination:
          this.userForm.get("formArray")["controls"][0].value.traveling_to !==
            ""
            ? this.userForm.get("formArray")["controls"][0].value.traveling_to
            : this.plan_details.destination,
        is_insurance: true,
        start_date: this.datePipe.transform(
          this.userForm.get("formArray")["controls"][0].value
            .coverage_start_date,
          "yyyy-MM-dd"
        ),
        end_date: this.datePipe.transform(
          this.userForm.get("formArray")["controls"][0].value.coverage_end_date,
          "yyyy-MM-dd"
        ),
        deduction:
          this.userForm.get("formArray")["controls"][1].value.deductable,
        max_coverage:
          this.userForm.get("formArray")["controls"][1].value.policy_limit,
        id: this.plan_details.id,
        company_id: this.plan_details.company_id,
        type: this.plan_details.type,
        ad_d_upgrade:
          this.userForm.get("formArray")["controls"][1].value
            .is_ad_d_options_info,
        sports:
          this.userForm.get("formArray")["controls"][1].value.sports_options,
        sports_rider:
          this.userForm.get("formArray")["controls"][1].value.sports_rider,
        plus_rider:
          this.userForm.get("formArray")["controls"][1].value.plus_rider,
        is_ad_d_options_info_global:
          this.userForm.get("formArray")["controls"][1].value
            .is_ad_d_options_info_global,
        travellers_dob: {
          primary:
            this.userForm.get("formArray")["controls"][0].value.primary_dob,
          spouse:
            this.userForm.get("formArray")["controls"][0].value.spouse_dob,
          child: this.userForm.get("formArray")["controls"][0].value.child1_dob,
          child1: this.isChild1 ? 
            this.userForm.get("formArray")["controls"][0].value.child2_dob : '',
          child2: this.isChild2 ? 
            this.userForm.get("formArray")["controls"][0].value.child3_dob : '',
        },
        dp_rider:
          this.userForm.get("formArray")["controls"][1].value.dp_rider,
        telehealth_rider:
          this.userForm.get("formArray")["controls"][1].value.telehealth_rider,
        payment_type : this.userForm.get("formArray")["controls"][0].value.payment_type ? this.userForm.get("formArray")["controls"][0].value.payment_type : '',
      };
      this.m_pService.getQuotePrices(quotesPrice).subscribe((response) => {
        console.log("getQuotes", response.result.data);
        if (response.result.success && response.result.data) {
          if (!response.result.data.status) {
            this.loader = false;
            this.buttonDisabled = false;
            this.errorMsg =
              response.result.data.msg != null
                ? response.result.data.msg
                : "Unable to get Quotes from this time.";
          } else {
            console.log(this.userForm.get("formArray")["controls"][1].value.state);
            this.errorMsg = "";
            this.primary_amount = response.result.data.details.primary
              ? parseFloat(response.result.data.details.primary.toString()).toFixed(2) 
              : "";
            this.is_telehealth = response.result.data.details.telehealth
              ? parseFloat(response.result.data.details.telehealth.toString()).toFixed(2) 
              : "";
            this.is_adventure_rider = response.result.data.details.adventure_sports
              ? parseFloat(response.result.data.details.adventure_sports.toString()).toFixed(2) 
              : "";
            this.spouse_amount = response.result.data.details.spouse
              ? parseFloat(response.result.data.details.spouse.toString()).toFixed(2)
              : "";
            this.child_amount = response.result.data.details.child
              ? parseFloat(response.result.data.details.child.toString()).toFixed(2)
              : "";
            this.child1_amount = response.result.data.details.child1
              ? parseFloat(response.result.data.details.child1.toString()).toFixed(2)
              : "";
            this.child2_amount = response.result.data.details.child2
              ? parseFloat(response.result.data.details.child2.toString()).toFixed(2)
              : "";
            this.total_amount = response.result.data.quote
              ? parseFloat((+response.result.data.quote + this.optionalCoverageAmount + this.policyAmount + this.additional_tax_amount).toString()).toFixed(2)
              : "";
              this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
            this.dobLabel = this.datePipe.transform(
              this.userForm.get("formArray")["controls"][0].value.primary_dob,
              "yyyy-MM-dd"
            );
            this.secondary_coverages = response.result.data.optional_coverage;
            this.is_secondary_coverages = response.result.data.is_secondary_coverages;
            this.userForm
              .get("formArray")
            ["controls"][1].controls.date_of_departure.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .coverage_start_date != ""
                ? this.datePipe.transform(
                  this.userForm.get("formArray")["controls"][0].value
                    .coverage_start_date,
                  "yyyy-MM-dd"
                )
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.date_of_return.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .coverage_end_date != ""
                ? this.datePipe.transform(
                  this.userForm.get("formArray")["controls"][0].value
                    .coverage_end_date,
                  "yyyy-MM-dd"
                )
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.country.patchValue(
              this.userForm.get("formArray")["controls"][0].value.residence !=
                ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .residence
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.mailing_country.patchValue(
              this.userForm.get("formArray")["controls"][0].value.residence !=
                ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .residence
                : ""
            );
            // this.userForm
            //   .get("formArray")
            //   ["controls"][2].controls.billing_country.patchValue(
            //     this.userForm.get("formArray")["controls"][0].value.residence !=
            //       ""
            //       ? this.userForm.get("formArray")["controls"][0].value
            //           .residence
            //       : ""
            //   );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.total_amount.patchValue(
              parseFloat((+response.result.data.quote + this.optionalCoverageAmount + this.policyAmount + this.additional_tax_amount).toString()).toFixed(2)
            );
            this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
            this.userForm.get("formArray")
            ["controls"][1].controls.total_payable_amount.patchValue(
              parseFloat((+this.totalPayable).toString()).toFixed(2)
            );
            this.isDisabled=false;
            this.userForm
              .get("formArray")
            ["controls"][1].controls.primary_citizenShip.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .citizenShip != ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .citizenShip
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.spouse_citizenShip.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .citizenShip != ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .citizenShip
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.child1_citizenShip.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .citizenShip != ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .citizenShip
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.child2_citizenShip.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .citizenShip != ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .citizenShip
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.child3_citizenShip.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .citizenShip != ""
                ? this.userForm.get("formArray")["controls"][0].value
                  .citizenShip
                : ""
            );
            let mADate = moment(
              this.userForm.get("formArray")["controls"][0].value.primary_dob
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.date_of_birth.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .primary_dob != ""
                ? moment(mADate).format()
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.spouse_date_of_birth.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .spouse_dob != ""
                ? moment(
                  this.userForm.get("formArray")["controls"][0].value
                    .spouse_dob
                ).format()
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.child1_date_of_birth.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .child1_dob != ""
                ? moment(
                  this.userForm.get("formArray")["controls"][0].value
                    .child1_dob
                ).format()
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.child2_date_of_birth.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .child2_dob != ""
                ? moment(
                  this.userForm.get("formArray")["controls"][0].value
                    .child2_dob
                ).format()
                : ""
            );
            this.userForm
              .get("formArray")
            ["controls"][1].controls.child3_date_of_birth.patchValue(
              this.userForm.get("formArray")["controls"][0].value
                .child3_dob != ""
                ? moment(
                  this.userForm.get("formArray")["controls"][0].value
                    .child3_dob
                ).format()
                : ""
            );
            if(this.userForm.get("formArray")["controls"][0].value
            .residence=='CA' || this.userForm.get("formArray")["controls"][0].value
            .residence=='AU'){
              
            }
            // this.primaryDOB_review =this.userForm.get('formArray')['controls'][0].value.primary_dob
            // this.userForm.get('formArray')['controls'][1].value.date_of_birth = this.userForm.get('formArray')['controls'][1].value.date_of_birth ? moment(this.userForm.get('formArray')['controls'][0].value.date_of_birth).format() : '';
            if (this.userForm.get('formArray')['controls'][0].value.citizenShip
              === this.userForm.get('formArray')['controls'][0].value.residence && 
              this.userForm.get('formArray')['controls'][0].value.citizenShip
              === this.userForm.get("formArray")["controls"][0].value.traveling_to
            ) {
              this.isCountryFieldsMatch = true;
              step = false;
            }
            if (step == true) {
              this.loader = false;
              this.buttonDisabled = false;
              this.matStepper.next();
              if(this.plan_details.company_id==4 ){
                switch(this.userForm.get("formArray")["controls"][0].value
                .residence){
                  case 'AU':
                    this.physicalLocationDailog('Australia','Country');
                  break;
                  case 'CA':
                    this.physicalLocationDailog('Canada','Country');
                  break;
                }
              }
            } else {
              console.log(this.userForm.get("formArray")["controls"][0].value
              .coverage_end_date)
              this.loader = false;
              this.coverageEndDate = moment(
                this.userForm.get("formArray")["controls"][0].value
                  .coverage_end_date,
                "YYYY-MM-DD"
              ).add(1, "days");
              console.log(this.coverageEndDate)
              this.buttonDisabled = false;
            }
          }
        }
        // this.notesPage = response.result.data.add_info;
        // this.deductions = response.result.data.deductions;
        // this.policyLimits = response.result.data.max_cov_options;
      });
    }
    
    // if(this.plan_details){
    // 	if(this.plan_details.month == "1" && this.userForm.get('formArray')['controls'][0].controls.noOfMonths.value > 1){
    // 		this.userForm.get('formArray')['controls'][1].controls.recurring_payment.value = 'checked';
    // 		this.showRecurring = true;
    // 		this.toogleRecurring = true;
    // 	}else{
    // 		this.showRecurring = false;
    // 		this.toogleRecurring = false;
    // 	}
    // 	this.total = parseFloat(this.plan_details.total_plans_amount);
    // }

    // if(this.userForm.get('formArray')['controls'][0].valid){

    // 	this.m_pService.getUserPreviousPlanAmount({startedate:this.effectiveMinDate, enddtate: this.userForm.get('formArray')['controls'][0].controls.termination_date.value, plan_id: App.plan_data.plan_id}).subscribe(response => {
    // 		if(response.result.data.old_plan_amount){
    // 			this.prevPlanAmount = response.result.data.old_plan_amount;
    // 			this.total = this.total - parseFloat(this.prevPlanAmount)
    // 			this.toogleRecurring = this.userForm.get('formArray')['controls'][0].controls.noOfMonths.value  == 1? true:false;
    // 			console.log(this.prevPlanAmount)
    // 		}
    // 	});
    // 	this.stripeService.changeKey('pk_test_51HYo8JIU6EOWyLAQKryyrgURPOR8bSywVMs6BvBkVmhFOCijgB5bCKJQYOvhjSR5Q29tJCQC8XrM1jMwemx2ofrg00IdhDUVqJ');
    // }else{
    // 	console.log('Form Not Validated, please recheck')
    // }
  }

  page3() {
    // this.matStepper.selected.editable = false;
  }

  page4() {
    this.form3Submitted = true;
    console.log(this.userForm.get("formArray")["controls"]);
    this.userForm.get("formArray")["controls"][1].value.date_of_return !== ""
      ? this.userForm
        .get("formArray")
      ["controls"][1].controls.date_of_return.patchValue(
        moment(
          this.userForm.get("formArray")["controls"][1].value.date_of_return
        ).format()
      )
      : "";
    this.userForm.get("formArray")["controls"][1].value.date_of_departure !== ""
      ? this.userForm
        .get("formArray")
      ["controls"][1].controls.date_of_departure.patchValue(
        moment(
          this.userForm.get("formArray")["controls"][1].value
            .date_of_departure
        ).format()
      )
      : "";
    if (this.userForm.get("formArray")["controls"][1].valid) {
      this.matStepper.next();
      this.isLoading = false;
      this.submitStatusMsg = true;
    }
  }

  page5() {
    this.buttonDisabled = true;
    this.loader = true;
    this.form4Submitted = true;
    this.userForm.value.formArray[1].secondary_coverages = this.selectedCoverages;
    this.userForm.value.formArray[1].total_amount = parseFloat((+this.total_amount + this.optionalCoverageAmount).toString()).toFixed(2);
    if (this.userForm.get("formArray")["controls"][2].valid) {
      this.m_pService
        .planPurchase({
          page1: this.userForm.value.formArray[0],
          page2: this.userForm.value.formArray[1],
          page3: this.userForm.value.formArray[2],
        })
        .subscribe((response) => {
          if (response.result.success && response.result.data) {
            if (!response.result.data.status) {
              this.buttonDisabled = false;
              this.loader = false;
              this.errorMsgFinal = response.result.data.msg;
            } else {
              this.buttonDisabled = false;
              this.loader = false;
              this.matStepper.next();
              this.isEditable = false;
              this.errorMsgFinal = "";
              // this.primary_amount = response.result.data.details.primary ? response.result.data.details.primary : '';
              // this.spouse_amount = response.result.data.details.spouse ? response.result.data.details.spouse : '';
              // this.child_amount = response.result.data.details.child ? response.result.data.details.child : '';
              // this.child1_amount = response.result.data.details.child1 ? response.result.data.details.child1 : '';
              // this.child2_amount = response.result.data.details.child2 ? response.result.data.details.child2 : '';
              // this.total_amount = response.result.data.quote ? response.result.data.quote : '';
              // step === true ? this.matStepper.next() : '';
            }
          }
          // this.notesPage = response.result.data.add_info;
          // this.deductions = response.result.data.deductions;
          // this.policyLimits = response.result.data.max_cov_options;
        });
      this.isLoading = false;
      this.submitStatusMsg = true;
    }
    else{
      this.buttonDisabled = false;
      this.loader = false;
    }
  }

  changedetectorfunc(value) {
    if (
      !this.userForm
        .get("formArray")
      ["controls"][0].controls.cell_phone.value.includes("-")
    ) {
      this.phoneMaxLength = 10;
      this.phoneMinLength = 10;
    } else {
      this.phoneMaxLength = 12;
      this.phoneMinLength = 12;
    }
  }

  getStates(countryCode) {
    this.m_pService.getStatesApi(countryCode).subscribe((response) => {
      this.States = response.result.data;
    });
  }

  setPrimary(event) {
    if (event.checked) {
      this.userForm
        .get("formArray")
      ["controls"][1].controls.first_name.patchValue(
        this.userForm.get("formArray")["controls"][1].value
          .primary_first_name != ""
          ? this.userForm.get("formArray")["controls"][1].value
            .primary_first_name
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.last_name.patchValue(
        this.userForm.get("formArray")["controls"][1].value
          .primary_last_name != ""
          ? this.userForm.get("formArray")["controls"][1].value
            .primary_last_name
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.email_confirm.patchValue(
        this.userForm.get("formArray")["controls"][0].value.email != ""
          ? this.userForm.get("formArray")["controls"][0].value.email
          : ""
      );
    } else {
      this.userForm
        .get("formArray")
      ["controls"][1].controls.first_name.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.last_name.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.email_confirm.patchValue("");
    }
  }
  setMailing(event) {
    if (event.checked) {
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_first_name.patchValue(
        this.userForm.get("formArray")["controls"][1].value.first_name != ""
          ? this.userForm.get("formArray")["controls"][1].value.first_name
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_last_name.patchValue(
        this.userForm.get("formArray")["controls"][1].value.last_name != ""
          ? this.userForm.get("formArray")["controls"][1].value.last_name
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_address_line_1.patchValue(
        this.userForm.get("formArray")["controls"][1].value.address_line_1 !=
          ""
          ? this.userForm.get("formArray")["controls"][1].value.address_line_1
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_address_line_2.patchValue(
        this.userForm.get("formArray")["controls"][1].value.address_line_2 !=
          ""
          ? this.userForm.get("formArray")["controls"][1].value.address_line_2
          : ""
      );
      // this.userForm.get('formArray')['controls'][1].controls.mailing_country.patchValue(this.userForm.get('formArray')['controls'][1].value.country != '' ? this.userForm.get('formArray')['controls'][1].value.country : '');
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_city.patchValue(
        this.userForm.get("formArray")["controls"][1].value.city != ""
          ? this.userForm.get("formArray")["controls"][1].value.city
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_state.patchValue(
        this.userForm.get("formArray")["controls"][1].value.state != ""
          ? this.userForm.get("formArray")["controls"][1].value.state
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_postal_code.patchValue(
        this.userForm.get("formArray")["controls"][1].value.postal_code != ""
          ? this.userForm.get("formArray")["controls"][1].value.postal_code
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_email_confirm.patchValue(
        this.userForm.get("formArray")["controls"][1].value.email_confirm !=
          ""
          ? this.userForm.get("formArray")["controls"][1].value.email_confirm
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_mobile.patchValue(
        this.userForm.get("formArray")["controls"][0].value.mobile != ""
          ? this.userForm.get("formArray")["controls"][0].value.mobile
          : ""
      );
    } else {
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_first_name.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_last_name.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_address_line_1.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_address_line_2.patchValue("");
      // this.userForm.get('formArray')['controls'][1].controls.mailing_country.patchValue('');
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_city.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_state.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_postal_code.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_email_confirm.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][1].controls.mailing_mobile.patchValue("");
    }
  }

  setBilled(event) {
    if (event.checked) {
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_first_name.patchValue(
        this.userForm.get("formArray")["controls"][1].value.first_name != ""
          ? this.userForm.get("formArray")["controls"][1].value.first_name
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_last_name.patchValue(
        this.userForm.get("formArray")["controls"][1].value.last_name != ""
          ? this.userForm.get("formArray")["controls"][1].value.last_name
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_address_line_1.patchValue(
        this.userForm.get("formArray")["controls"][1].value.address_line_1 !=
          ""
          ? this.userForm.get("formArray")["controls"][1].value.address_line_1
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_address_line_2.patchValue(
        this.userForm.get("formArray")["controls"][1].value.address_line_2 !=
          ""
          ? this.userForm.get("formArray")["controls"][1].value.address_line_2
          : ""
      );
      this.userForm.get('formArray')['controls'][2].controls.billing_country.patchValue(this.userForm.get('formArray')['controls'][1].value.country != '' ? this.userForm.get('formArray')['controls'][1].value.country : '');
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_city.patchValue(
        this.userForm.get("formArray")["controls"][1].value.city != ""
          ? this.userForm.get("formArray")["controls"][1].value.city
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_state.patchValue(
        this.userForm.get("formArray")["controls"][1].value.state != ""
          ? this.userForm.get("formArray")["controls"][1].value.state
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_postal_code.patchValue(
        this.userForm.get("formArray")["controls"][1].value.postal_code != ""
          ? this.userForm.get("formArray")["controls"][1].value.postal_code
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_email_confirm.patchValue(
        this.userForm.get("formArray")["controls"][1].value.email_confirm !=
          ""
          ? this.userForm.get("formArray")["controls"][1].value.email_confirm
          : ""
      );
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_mobile.patchValue(
        this.userForm.get("formArray")["controls"][1].value.mobile != ""
          ? this.userForm.get("formArray")["controls"][1].value.mobile
          : ""
      );
      // this.userForm.get('formArray')['controls'][3].controls.billing_mobile_msg.patchValue(this.userForm.get('formArray')['controls'][2].value.email_confirm != '' ? this.userForm.get('formArray')['controls'][2].value.email_confirm : '');
    } else {
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_first_name.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_last_name.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_address_line_1.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_address_line_2.patchValue("");
      this.userForm.get('formArray')['controls'][2].controls.billing_country.patchValue('');
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_city.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_state.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_postal_code.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_email_confirm.patchValue("");
      this.userForm
        .get("formArray")
      ["controls"][2].controls.billing_mobile.patchValue("");
    }
  }

  setMobileMsg(event) {
    if (event.checked) {
    } else {
    }
  }

  setAck(event) {
    if (event.checked) {
    } else {
    }
  }

  toogleChild(value, task) {
    if (task == "open") {
      switch (value) {
        case 1:
          this.isChild1 = true;
          break;
        case 2:
          this.isChild2 = true;
          break;
        default:
          break;
      }
    } else {
      switch (value) {
        case 1:
          this.isChild1 = false;
          break;
        case 2:
          this.isChild2 = false;
          break;
        default:
          // code...
          break;
      }
    }
  }

  toggleToolTip() {
    var tooler = document.getElementById("custmToolTip");
    if (tooler.style.display === "none") {
      tooler.style.display = "block";
    } else {
      tooler.style.display = "none";
    }
  }
  loadAdditionSalesTax(event) {
    if(this.plan_details.company_id==4 ){
    switch (event.value) {
      case "FL":
        let quotesPrice = {
          secondary_coverages: this.selectedCoverages,
          citizenship:
            this.userForm.get("formArray")["controls"][0].value.citizenShip,
          destination:
            this.userForm.get("formArray")["controls"][0].value.traveling_to !==
              ""
              ? this.userForm.get("formArray")["controls"][0].value.traveling_to
              : this.plan_details.destination,
          is_insurance: true,
          start_date: this.datePipe.transform(
            this.userForm.get("formArray")["controls"][0].value
              .coverage_start_date,
            "yyyy-MM-dd"
          ),
          end_date: this.datePipe.transform(
            this.userForm.get("formArray")["controls"][0].value.coverage_end_date,
            "yyyy-MM-dd"
          ),
          deduction:
            this.userForm.get("formArray")["controls"][1].value.deductable,
          max_coverage:
            this.userForm.get("formArray")["controls"][1].value.policy_limit,
          id: this.plan_details.id,
          company_id: this.plan_details.company_id,
          type: this.plan_details.type,
          ad_d_upgrade:
            this.userForm.get("formArray")["controls"][1].value
              .is_ad_d_options_info,
          sports:
            this.userForm.get("formArray")["controls"][1].value.sports_options,
          sports_rider:
            this.userForm.get("formArray")["controls"][1].value.sports_rider,
          plus_rider:
            this.userForm.get("formArray")["controls"][1].value.plus_rider,
          is_ad_d_options_info_global:
            this.userForm.get("formArray")["controls"][1].value
              .is_ad_d_options_info_global,
          travellers_dob: {
            primary:
              this.userForm.get("formArray")["controls"][0].value.primary_dob,
            spouse:
              this.userForm.get("formArray")["controls"][0].value.spouse_dob,
            child: this.userForm.get("formArray")["controls"][0].value.child1_dob,
            child1: this.isChild1 ? 
              this.userForm.get("formArray")["controls"][0].value.child2_dob : '',
            child2: this.isChild2 ? 
              this.userForm.get("formArray")["controls"][0].value.child3_dob : ''
            },
            state : event.value,
            payment_type : this.userForm.get("formArray")["controls"][0].value.payment_type ? this.userForm.get("formArray")["controls"][0].value.payment_type : '',

        };
        this.m_pService.getQuotePrices(quotesPrice).subscribe((response) => {
          if (!response.result.data.status) {
            this.loader = false;
            this.buttonDisabled = false;
            this.errorMsg =
              response.result.data.msg != null
                ? response.result.data.msg
                : "Unable to get Total Surplus Lines Tax from this time.";
          } else {
          this.is_addition_tax=true;
          this.additional_tax_amount = response.result.data.tax;
          this.total_amount = parseFloat((+this.total_amount + this.additional_tax_amount).toString()).toFixed(2);
          this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
          }
        });
        break;
        case "MD":
          this.physicalLocationDailog('Maryland','State');
        break;
        case "NY":
          this.physicalLocationDailog('NewYork','State');
        break;
      default:
        this.is_addition_tax=false;
        if(this.additional_tax_amount>0){
        this.total_amount = parseFloat((+this.total_amount - this.additional_tax_amount).toString()).toFixed(2);
        this.totalPayable= parseFloat((+this.total_amount + this.shippingCost).toString()).toFixed(2);
        this.additional_tax_amount = 0;
        }
        break;
    }
  }
    
  }
  physicalLocationDailog(name:string,type:string){
    if(this.plan_details.company_id==4 ){
      const confirmDialog = this.dialog.open(PhysicalLocationComponent, {
        panelClass: 'alert-dialog',
        width: '500px',
        disableClose: true ,
        data: {
          dialog: false,
          title: "Your Physical Location",
          message:
            `If the proposed insured is physically located in ${type} of ${name} this qouting session, then purchase of this policy is prohibited and must be cancelled by clicking the cancel button. Otherwise, please click continue`,
          url:App.froent_end_url
        },
      });
      confirmDialog.afterClosed().subscribe((result) => {
      console.log(result);
      });
    }
  }
}
